if (!customElements.get("sizechart-table")) {
    class sizeChart extends HTMLElement {
      constructor() {
        super();
  
        this.optionsRow = this.querySelectorAll('tr');
        this.scaleTrigger = this.querySelectorAll('[data-matrix]');
        this.sizeChartData = this.querySelectorAll('td.chart-value');
        this.sizeChartTableHeader = this.querySelectorAll('th[data-matix]');
        this.tabTriggers = this.querySelectorAll('[data-tab-id]');
        this.atcBtn = this.querySelector('[ḍata-sizechart-atc]');
        this.closeModalTrigger = this.querySelector('[data-close-size-chart]');
        this.modelCloseTrigger = this.closest('#quickViewModal')?.querySelector('#sizeChartModal [data-size-chart-close]');
      }
      connectedCallback() {
        // this.querySelectorAll(".product__color-swatches--js").forEach((btn) => {
        //     btn.addEventListener("click", this.onVariantChange.bind(this), false);
        //   }); 
        this.optionsRow?.forEach(tr => tr.addEventListener('click', this.handleSizeChargeChange.bind(this)));
        this.scaleTrigger?.forEach(tr => tr.addEventListener('click', this.manageTabScale.bind(this)));
        this.tabTriggers?.forEach(tr => tr.addEventListener('click', this.toggleTabs.bind(this)));
        this.closeModalTrigger?.addEventListener('click', this.closeModal.bind(this));
        this.atcBtn?.addEventListener('click', (e) => {
          e.preventDefault();
  
          // let variantOptions = e.currentTarget.closest('.main-template-product').querySelectorAll('variant-selector .option-variant-wrapper');
          // if(variantOptions) {
          //   let allOptionSelected = true;
          //   variantOptions.forEach(variantOpt => {
          //     let selectedOpt = variantOpt.querySelector('input:checked');
          //     if (!selectedOpt) {
          //       allOptionSelected = false;
          //       let errorElement = variantOpt.querySelector('.error-message');
          //       errorElement.classList.remove('d-none');
                
          //       const elementPosition = errorElement.getBoundingClientRect().top + window.scrollY;
          //       window.scrollTo({
          //         top: elementPosition - 200,
          //         behavior: 'smooth'
          //       });
                
          //       setTimeout(() => {
          //         errorElement.classList.add('d-none');
          //       }, 6000);
          //     }
          //   });
          //   if (allOptionSelected == false) {
          //     this.closeModal(); 
          //     return false;  
          //   }
          // }
  
          if (this.closest('#quickViewModal')) {
            var atcMainBtn = this.closest('#quickViewModal')?.querySelector('product-form form button[type="submit"]');
          } else {
            var atcMainBtn = document.querySelector('.pdp-content-wrapper')?.querySelector('form [name="add"]');
          }
          atcMainBtn?.click();
          atcMainBtn?.dispatchEvent(new Event('click'));
          this.atcBtn?.setAttribute('disabled', true);
          this.closeModal(); 
        })
        this.modelCloseTrigger?.addEventListener('click', (e) => {
          this.closest('#sizeChartModal')?.hide();
        })
      }
      onVariantChange() {
        
            
          this.optionsRow.forEach(tr => {
            (tr.dataset.variantId == e.detail.id) ? tr.classList.add('selected') : tr.classList.remove('selected');
            if (e.detail.available) {
              this.atcBtn.disabled = false;
              this.atcBtn.textContent = window.variantStrings.addToCart;
            } else {
              this.atcBtn.disabled = true;
              this.atcBtn.textContent = window.variantStrings.soldOut;
            }
          })
      }
      handleSizeChargeChange(event) {
        event.preventDefault();
        if(event.currentTarget.closest('#quickViewModal')) {
          var optInput = event.currentTarget.closest('#quickViewModal')?.querySelectorAll('product-form form variant-selector [data-size-opt]');
        } else {
          var optInput = document.querySelector('.product-detail__information')?.querySelectorAll('[data-size-opt]');
        }
        console.log(event.currentTarget.dataset.optValue);  
        optInput?.forEach(radio => {
          if (radio.value == event.currentTarget.dataset.optValue) {
            radio.dispatchEvent(new Event('change'));
            radio.click(); 
          }
        });
      }
      manageTabScale(event) {
        event.preventDefault();
        if (event.currentTarget.classList.contains('active')) return; 
        this.scaleTrigger.forEach(ele => ele.classList.remove('active'));
        event.currentTarget.classList.add('active');
        this.sizeChartData?.forEach(td => {
          const originalText = td.textContent;
          let newText = '';
        
          if (event.currentTarget.dataset.matrix == 'in') {
            // If the data is in cm, convert each number to inches
            newText = originalText.split('x').map(value => {
              // Convert and round, removing ".0" if it's an integer
              let inchValue = (parseFloat(value.replace(/[^\d.-]/g, '')) / 2.54).toFixed(1);
              return inchValue.endsWith('.0') ? inchValue.slice(0, -2) + '"' : inchValue + '"';
            }).join(' x ');
        
            this.sizeChartTableHeader?.forEach(th => th.setAttribute('data-matix', 'in'));
          } else {
            // If the data is in inches, convert each number to cm
            newText = originalText.split('x').map(value => {
              // Convert and round, removing ".0" if it's an integer
              let cmValue = (parseFloat(value.replace(/[^\d.-]/g, '')) * 2.54).toFixed(1);
              return cmValue.endsWith('.0') ? cmValue.slice(0, -2)  : cmValue ;
            }).join(' x ');
        
            this.sizeChartTableHeader?.forEach(th => th.setAttribute('data-matix', 'cm'));
          }
        
          // Update the content of the chart-value cell
          td.textContent = newText;
        });
        
      }
      toggleTabs(event) {
        event.preventDefault();
        this.tabTriggers.forEach(ele => ele.classList.remove('active'));
        event.currentTarget.classList.add('active');
        let tabIdEle = this.querySelector(`#${event.currentTarget.dataset.tabId}`);
        this.scrollTo({
          top: (tabIdEle.offsetTop - this.offsetTop) - 40,
          left: 0,
          behavior: "smooth",
        });
      }
      closeModal(event) {
        event?.preventDefault();
        document.querySelector('.size-chart-index')?.classList.remove('active');
        document.querySelector('.pdp-main-wrapper')?.classList.remove('index-5');
      }
    }
    customElements.define("sizechart-table", sizeChart);
  
    let sizeChartTrigger = document.querySelector("#sizeguideTrigger");
    if(sizeChartTrigger) {
      sizeChartTrigger.addEventListener("click", e => {
        e.preventDefault(); 
        if(window.innerWidth > 767) {
          let sizeChartAcco = document.querySelector('[data-size-chart]');
          if(sizeChartAcco)   sizeChartAcco.classList.add('active'); 
          sizeChartAcco.querySelector('.collapsible-content').style.display = 'block';
          let offsetTop = sizeChartAcco.offsetTop - 50 - document.querySelector("#header-sticky").clientHeight;
          window.scrollTo({
            top: offsetTop,
            left: 0, 
            behavior: "smooth"
          })
        } else {
          let sizeChartAcco = document.querySelector('[data-size-chart]');
          if(sizeChartAcco) sizeChartAcco.classList.add('active');
          document.querySelector('.size-chart-index')?.classList.add('active'); 
          sizeChartAcco.querySelector('.collapsible-content').style.display = 'block';
          document.querySelector('.pdp-main-wrapper')?.classList.add('index-5');
        }
      });
    }
  
    let sizeVarTrigger = document.querySelector("#sizevarTrigger");
    sizeVarTrigger && sizeVarTrigger.addEventListener("click", e => {
      e.preventDefault(); 
      if(window.innerWidth <= 767 && __st.rtyp == "product") {
        document.body.style.overflow = "hidden";
        document.querySelector(".size-chart-index").classList.add("active");
        document.querySelector('.pdp-main-wrapper')?.classList.add('index-5');
        document.querySelector(".size-chart-acco-wrapper .acco-title").classList.add("active");
        document.querySelector(".size-chart-acco-wrapper .acco-content").style.display = "block";
      }
    })
  }